module.exports = __webpack_public_path__ + "img/oriente.7091e6fc.png";